import * as React from 'react'
import * as classNames from 'classnames'
import { motion, AnimatePresence } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircleCheck,
  faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons'

import { isMobileDisplay } from '@/utils/devise'

import * as Style from './style.css'

export interface IProps extends React.PropsWithChildren {
  visible?: boolean
  title?: string
  children?: React.ReactNode
  color?: 'warning' | 'notice' | 'alert'
}

const FADE_IN_ANIMATION_SETTING = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
  transition: { duration: 0.3, ease: 'easeOut' },
}
const SLIDE_UP_ANIMATION_SETTING = {
  initial: { y: '100%' },
  animate: { y: 0 },
  exit: { y: '100%' },
  transition: { duration: 0.3 },
}

export const Toast = ({
  visible,
  title,
  children,
  color,
}: IProps): JSX.Element => {
  const animationSetting = isMobileDisplay()
    ? FADE_IN_ANIMATION_SETTING
    : SLIDE_UP_ANIMATION_SETTING

  const statusClass = {
    [Style.ToastContainer]: true,
    [Style.ToastContainerNotice]: color === 'notice',
    [Style.ToastContainerAlert]: color === 'alert',
  }
  return (
    <AnimatePresence>
      {visible && (
        <motion.div {...animationSetting} className={Style.Toast}>
          <div className={classNames(statusClass)}>
            {color === 'notice' && (
              <div className={Style.ToastHead}>
                <FontAwesomeIcon
                  icon={faCircleCheck}
                  className={Style.ToastHeadIconNotice}
                />
                <span className={Style.ToastHeadTitleNotice}>{title}</span>
              </div>
            )}
            {color === 'alert' && (
              <div className={Style.ToastHead}>
                <FontAwesomeIcon
                  icon={faCircleExclamation}
                  className={Style.ToastHeadIconAlert}
                />
                <span className={Style.ToastHeadTitleAlert}>{title}</span>
              </div>
            )}
            {children && <div className={Style.ToastContent}>{children}</div>}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
